// Auth routes
export const SIGN_IN_ENDPOINT = '/auth/login';
export const SIGN_UP_ENDPOINT = '/auth/register';
export const PASSWORD_RESET_ENDPOINT = '/auth/password/reset';
export const PASSWORD_REQUEST_TOKEN_ENDPOINT = '/auth/password/reset/token';
export const VERIFY_EMAIL_ENDPOINT = '/auth/verify-email/{code}';
export const USER_ENDPOINT = '/auth/user';
